export default {"src":"/_next/static/media/mojavez-ir.110f75cc.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};